<li class="margin-bottom-20">
  <strong>
      <a (click)="showAllChildTopics()">{{ topic.TopicInformation.Title }}</a>
  </strong>

  <div class="margin-left-20" class="margin-top-5 margin-bottom-5" style="line-height: 25px">
      <div *ngIf="getShortTopicChildrenListVisibiliy()">
        <span *ngFor="let achild of topic.Children; let i=index">
          <span *ngIf="i < 4 && i > 0" class="topic-divider">|</span>
          <a *ngIf="i < 4" (click)="showContentEntriesFromShortTopicList(achild.TopicInformation.Alias)">{{ achild.TopicInformation.Title }}</a> 
        </span>
        <span *ngIf="topic.Children.length > 3" class="topic-divider">|</span>
        <a *ngIf="topic.Children.length > 3" (click)="showAllChildTopics()" [routerLink]="">More... </a> 
      </div>                        

      <div *ngIf="getLongTopicChildrenListVisibiliy()" class="margin-top-5 margin-bottom-5">
          <span *ngFor="let achild2 of topic.Children" style="display: block;" class="margin-top-5 margin-bottom-5">
            <a (click)="showContentEntries(achild2.TopicInformation.Alias)" ><i style="color: #337ab7;" [ngClass]="getIconClass(achild2.TopicInformation.Alias)"></i>{{ achild2.TopicInformation.Title }}</a><br>
            <div *ngIf="getShowContentEntries(achild2.TopicInformation.Alias, myCurrentElement)" id="{{achild2.TopicInformation.Alias}}" #myCurrentElement>
                <div class="margin-left-40">
                    <span *ngFor="let aContentEntry of achild2.contentEntries" class="padding-bottom-5 padding-top-5" style="display: block">
                      <a (click)="onShowContentEntry(achild2, aContentEntry)" >{{ aContentEntry.Information.Title }}</a><br>
                    </span>
                </div>
            </div>
          </span>
        </div>
    </div>
</li>